import React, { createContext, useContext, useEffect, useState } from "react";

const LanguageContext = createContext(null);
export const useLanguage = () => useContext(LanguageContext);

const TR = {
  en: {
    "nav.searchRide": "Search a ride", "nav.bus": "Bus tickets", "nav.explore": "Explore",
    "nav.publish": "Publish a ride", "nav.login": "Log in", "nav.dashboard": "Dashboard",
    "nav.messages": "Messages", "nav.profile": "My profile", "nav.logout": "Log out",
    "sw.from": "From", "sw.to": "To", "sw.date": "Date", "sw.seats": "Seats",
    "sw.search": "Search", "sw.anyDate": "Any date", "sw.leavingFrom": "Leaving from", "sw.goingTo": "Going to",
    "home.badge": "Carpooling from another galaxy",
    "home.title1": "Share the ride,", "home.title2": "split the stardust",
    "home.subtitle": "Find affordable rides between Thailand's provinces with trusted drivers, or publish your own trip and fill those empty seats. Fun, friendly, out of this world.",
    "home.trust.verified": "Verified profiles", "home.trust.price": "Best prices", "home.trust.rated": "Rated drivers",
    "home.stats.rides": "live rides", "home.stats.drivers": "cosmic drivers", "home.stats.bus": "bus trips",
    "home.popular": "Popular routes", "home.seeAll": "See all", "home.from": "from", "home.perSeat": "per seat",
    "home.how": "How Shareride works",
    "home.step1t": "Search your ride", "home.step1d": "Enter your route and date. Compare trusted drivers, prices and reviews in seconds.",
    "home.step2t": "Book instantly", "home.step2d": "Reserve your seat and pay with PromptPay. No waiting for the mothership.",
    "home.step3t": "Travel together", "home.step3d": "Meet your driver, hop in, and share the journey (and the costs).",
    "home.busTitle": "Prefer the bus? Take a Starliner.", "home.busDesc": "Comfy long-distance coaches with Wi-Fi, power and extra legroom.", "home.busCta": "Explore bus tickets",
    "auth.join": "Join the Shareride galaxy", "auth.joinDesc": "Book a seat, split the costs, and travel with friendly humans (and the occasional alien). Trusted profiles, ratings, and instant booking.",
    "auth.login": "Log in", "auth.signup": "Sign up", "auth.email": "Email", "auth.password": "Password",
    "auth.name": "Full name", "auth.loginBtn": "Log in", "auth.createBtn": "Create account",
    "auth.or": "or", "auth.google": "Continue with Google", "auth.terms": "By continuing you agree to our cosmic Terms & Privacy.",
  },
  th: {
    "nav.searchRide": "ค้นหาการเดินทาง", "nav.bus": "ตั๋วรถทัวร์", "nav.explore": "สำรวจ",
    "nav.publish": "ลงประกาศทริป", "nav.login": "เข้าสู่ระบบ", "nav.dashboard": "แดชบอร์ด",
    "nav.messages": "ข้อความ", "nav.profile": "โปรไฟล์ของฉัน", "nav.logout": "ออกจากระบบ",
    "sw.from": "ต้นทาง", "sw.to": "ปลายทาง", "sw.date": "วันที่", "sw.seats": "ที่นั่ง",
    "sw.search": "ค้นหา", "sw.anyDate": "ทุกวัน", "sw.leavingFrom": "ออกเดินทางจาก", "sw.goingTo": "ไปยัง",
    "home.badge": "การเดินทางร่วมกันจากกาแล็กซีอื่น",
    "home.title1": "แชร์การเดินทาง", "home.title2": "แบ่งกันจ่าย",
    "home.subtitle": "ค้นหาการเดินทางราคาดีระหว่างจังหวัดทั่วไทยกับคนขับที่ไว้ใจ หรือลงประกาศทริปของคุณเองเพื่อเติมที่นั่งว่าง",
    "home.trust.verified": "โปรไฟล์ยืนยัน", "home.trust.price": "ราคาดีที่สุด", "home.trust.rated": "คนขับมีเรตติ้ง",
    "home.stats.rides": "เที่ยวที่เปิดให้จอง", "home.stats.drivers": "คนขับ", "home.stats.bus": "เที่ยวรถทัวร์",
    "home.popular": "เส้นทางยอดนิยม", "home.seeAll": "ดูทั้งหมด", "home.from": "เริ่มต้น", "home.perSeat": "ต่อที่นั่ง",
    "home.how": "Shareride ทำงานอย่างไร",
    "home.step1t": "ค้นหาเที่ยว", "home.step1d": "ใส่เส้นทางและวันที่ เปรียบเทียบคนขับ ราคา และรีวิวได้ในไม่กี่วินาที",
    "home.step2t": "จองทันที", "home.step2d": "จองที่นั่งและจ่ายด้วย PromptPay ได้ทันที",
    "home.step3t": "เดินทางด้วยกัน", "home.step3d": "เจอคนขับ ขึ้นรถ และแบ่งปันการเดินทาง (และค่าใช้จ่าย)",
    "home.busTitle": "ชอบรถทัวร์มากกว่า? ลอง Starliner", "home.busDesc": "รถโค้ชระยะไกลสุดสบาย มี Wi-Fi ที่ชาร์จไฟ และที่วางขากว้าง", "home.busCta": "ดูตั๋วรถทัวร์",
    "auth.join": "เข้าร่วมกับ Shareride", "auth.joinDesc": "จองที่นั่ง แบ่งค่าใช้จ่าย และเดินทางไปกับเพื่อนใหม่ โปรไฟล์น่าเชื่อถือ มีเรตติ้ง และจองได้ทันที",
    "auth.login": "เข้าสู่ระบบ", "auth.signup": "สมัคร", "auth.email": "อีเมล", "auth.password": "รหัสผ่าน",
    "auth.name": "ชื่อ-นามสกุล", "auth.loginBtn": "เข้าสู่ระบบ", "auth.createBtn": "สร้างบัญชี",
    "auth.or": "หรือ", "auth.google": "ดำเนินการต่อด้วย Google", "auth.terms": "การดำเนินการต่อถือว่าคุณยอมรับข้อกำหนดและความเป็นส่วนตัวของเรา",
  },
};

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem("shareride_lang") || "en");
  useEffect(() => { localStorage.setItem("shareride_lang", lang); }, [lang]);
  const t = (key) => (TR[lang] && TR[lang][key]) || TR.en[key] || key;
  const toggle = () => setLang((l) => (l === "en" ? "th" : "en"));
  return (
    <LanguageContext.Provider value={{ lang, setLang, toggle, t }}>
      {children}
    </LanguageContext.Provider>
  );
};
